import { formatCurrency, formatPercent } from './utils.js'

export function calculateCashBalanceFormulaCredit(formula = {}, compensation = 0, facts = {}) {
  const pay = Math.max(0, Number(compensation) || 0)
  if (formula.method === 'serviceGraded' || Array.isArray(formula.serviceBands)) {
    if (facts.serviceYears === null || facts.serviceYears === undefined || facts.serviceYears === '') return 0
    const serviceYears = Number(facts.serviceYears)
    if (!Number.isFinite(serviceYears)) return 0
    const band = (formula.serviceBands || [])
      .filter((entry) => serviceYears >= (Number(entry.minYears) || 0)
        && (entry.maxYears === null || entry.maxYears === undefined || serviceYears <= Number(entry.maxYears)))
      .sort((a, b) => (Number(b.minYears) || 0) - (Number(a.minYears) || 0))[0]
    if (!band) return 0
    return Math.max(0, (Number(band.flatDollar) || 0) + ((Number(band.percentOfPay) || 0) / 100) * pay)
  }
  if (formula.method === 'permittedDisparity') {
    const integrationLevel = Number.isFinite(Number(formula.integrationLevel))
      ? Math.max(0, Number(formula.integrationLevel))
      : Math.max(0, Number(facts.taxableWageBase) || 0)
    const base = ((Number(formula.basePercent) || 0) / 100) * pay
    const excess = ((Number(formula.excessPercent) || 0) / 100) * Math.max(0, pay - integrationLevel)
    return Math.max(0, base + excess)
  }
  if (Number.isFinite(formula.percentOfComp)) {
    return (formula.percentOfComp / 100) * pay
  }
  return Number.isFinite(formula.flatDollar) ? Math.max(0, formula.flatDollar) : 0
}

export function describeCashBalanceFormula(formula = {}) {
  if (formula.method === 'serviceGraded') return 'Service-graded pay credit schedule'
  if (formula.method === 'permittedDisparity') {
    return `${formatPercent(formula.basePercent || 0)} of pay plus ${formatPercent(formula.excessPercent || 0)} above the integration level`
  }
  if (Number.isFinite(formula.percentOfComp)) return `${formatPercent(formula.percentOfComp)} of pay`
  if (Number.isFinite(formula.flatDollar)) return formatCurrency(formula.flatDollar)
  return 'No adopted credit'
}
